var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovieReelOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14C4 8.47715 8.47715 4 14 4C19.5228 4 24 8.47715 24 14C24 19.5228 19.5228 24 14 24C8.47715 24 4 19.5228 4 14ZM20.6356 24C23.869 21.8502 26 18.1739 26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26H25C25.5523 26 26 25.5523 26 25C26 24.4477 25.5523 24 25 24H20.6356Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.25C7.5 8.73122 8.73122 7.5 10.25 7.5C11.7688 7.5 13 8.73122 13 10.25C13 11.7688 11.7688 13 10.25 13C8.73122 13 7.5 11.7688 7.5 10.25ZM10.25 9.5C9.83579 9.5 9.5 9.83579 9.5 10.25C9.5 10.6642 9.83579 11 10.25 11C10.6642 11 11 10.6642 11 10.25C11 9.83579 10.6642 9.5 10.25 9.5Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 15C8.73122 15 7.5 16.2312 7.5 17.75C7.5 19.2688 8.73122 20.5 10.25 20.5C11.7688 20.5 13 19.2688 13 17.75C13 16.2312 11.7688 15 10.25 15ZM9.5 17.75C9.5 17.3358 9.83579 17 10.25 17C10.6642 17 11 17.3358 11 17.75C11 18.1642 10.6642 18.5 10.25 18.5C9.83579 18.5 9.5 18.1642 9.5 17.75Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.25C15 8.73122 16.2312 7.5 17.75 7.5C19.2688 7.5 20.5 8.73122 20.5 10.25C20.5 11.7688 19.2688 13 17.75 13C16.2312 13 15 11.7688 15 10.25ZM17.75 9.5C17.3358 9.5 17 9.83579 17 10.25C17 10.6642 17.3358 11 17.75 11C18.1642 11 18.5 10.6642 18.5 10.25C18.5 9.83579 18.1642 9.5 17.75 9.5Z",
    fill: "#023F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 15C16.2312 15 15 16.2312 15 17.75C15 19.2688 16.2312 20.5 17.75 20.5C19.2688 20.5 20.5 19.2688 20.5 17.75C20.5 16.2312 19.2688 15 17.75 15ZM17 17.75C17 17.3358 17.3358 17 17.75 17C18.1642 17 18.5 17.3358 18.5 17.75C18.5 18.1642 18.1642 18.5 17.75 18.5C17.3358 18.5 17 18.1642 17 17.75Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieReelOutline);
export default __webpack_public_path__ + "static/media/movie_reel_outline.e8d2025ee94879fbe6ca197e8e34489a.svg";
export { ForwardRef as ReactComponent };